import { render, staticRenderFns } from "./KLoading.vue?vue&type=template&id=26362aca&scoped=true&"
import script from "./KLoading.vue?vue&type=script&lang=js&"
export * from "./KLoading.vue?vue&type=script&lang=js&"
import style0 from "./KLoading.vue?vue&type=style&index=0&id=26362aca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26362aca",
  null
  
)

export default component.exports